import { HttpParameterCodec, HttpParams, HttpRequest } from '@angular/common/http';
import { environment } from '@app/../environments/environment';
import { API_BASE_URL } from '@app/app.constants';

/**
 * Transforms a plain object to a HttpParams object ({ [key]: [value] })
 * @param payload Object to transform
 */
export function toHttpParams(payload: object) {
  let params: HttpParams = new HttpParams();

  for (const [key, value] of Object.entries(payload)) {
    if (value !== undefined) {
      params = params.set(key, value);
    }
  }

  return params;
}

/**
 * Sets `X-Portal-Version` request header with portal version value from environment
 * @param req the request
 */
export function setPortalVersionHeadOnRequest(req: HttpRequest<any>): HttpRequest<any> {
  if (req.url.startsWith(API_BASE_URL)) {
    return req.clone({ setHeaders: { 'X-Portal-Version': environment.version } });
  }
  return req;
}

/**
 * Angular does not correctly encode uri components, which can result in wrong parameters.
 * e.g. when trying to send a query parameter that contains a "+" sign, then it will not be escaped
 * and it will be interpreted as a " " (as is the default for a "+" sign in the url). On the other
 * hand, it will encode something like "%25" (which is the encoded "+" sign) to "%252B". Therefore
 * it is also not possible to encode the http params directly when calling http functions. That is
 * why this encoder is needed.
 */
export const CustomURLEncoder: HttpParameterCodec = {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  },

  encodeValue(key: string): string {
    return encodeURIComponent(key);
  },

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  },

  decodeValue(key: string) {
    return decodeURIComponent(key);
  },
};
